import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

interface ConfirmDeleteProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const ConfirmDeleteCustom = ({ open, onCancel, onConfirm }: ConfirmDeleteProps) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="confirm-delete-title"
            aria-describedby="confirm-delete-description"
            maxWidth="xs"
            fullWidth>
            <DialogTitle id="confirm-delete-title">
                <Stack direction="row" alignItems="center" spacing={1}>
                    <WarningAmberIcon sx={{ color: 'red' }} />
                    <Typography variant="h6">Xác nhận xóa</Typography>
                </Stack>
            </DialogTitle>

            <DialogContent>
                <Typography id="confirm-delete-description">
                    Bạn có chắc muốn xóa bản ghi này không? Sau khi xóa sẽ không thể khôi phục dữ liệu.
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button variant="contained" color="error" onClick={onConfirm}>
                    Xóa
                </Button>
                <Button variant="outlined" color="inherit" onClick={onCancel}>
                    Hủy
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteCustom;
